// Module-level mirror of the current user's `localAuthManagedByIdp` flag.
//
// The api-client step-up middleware (`isFederatedUser` predicate) needs a
// LAZY, synchronous read of "is the current user federated" so it can take
// the IdP-redirect path on a 403 step_up_required. The session itself lives
// in React state inside <SessionProvider>, but the `apiClient` is constructed
// at module-load time (in each app's `main.tsx`), long before React renders —
// so there is no context to read from at client-creation time.
//
// This tiny module bridges that gap: <SessionProvider> writes the flag here
// whenever session state settles, and the app passes
// `isFederatedUser: isFederatedUser` (the lazy getter below) into
// `createApiClient`. The predicate is evaluated at 403 time, by which point
// the provider has populated the flag.
//
// Pure module state. No React, no DOM. Safe to import anywhere.

let federated = false;

/** Lazy read used by the step-up middleware predicate. */
export function isFederatedUser(): boolean {
  return federated;
}

/** Set by <SessionProvider> as session state changes. */
export function setFederatedUser(value: boolean): void {
  federated = value;
}
